import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-check-performance',
  templateUrl: './check-performance.component.html',
  styleUrls: ['./check-performance.component.scss']
})
export class CheckPerformanceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
